export default "__VITE_ASSET__D8z7NlyW__"